// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/store'
import less from 'less'
import ElementUI  from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import 'viewerjs/dist/viewer.css';
import Viewer  from  'v-viewer'
import i18n from './locales'

Vue.config.productionTip = false

Vue.use(less)
Vue.use(ElementUI);
Vue.use(Viewer);
/* eslint-disable no-new */
Vue.filter('substringTime', function (time) {
  let txt=time.substring(0,10);
  return txt
})

Vue.filter('capitalize', function (val) {
  let time = val.slice(0, 11)
  return time
})



new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  i18n
})



// WEBPACK FOOTER //
// ./src/main.js